import secure from "../assets/images/secure.svg"
import support from "../assets/images/support.svg"
import custom from "../assets/images/customize.svg"
import reliable from "../assets/images/reliable.svg"
import fast from "../assets/images/fast.svg"
import easy from "../assets/images/easy.svg"
import dollar from "../assets/images/dollar.svg"
import star from "../assets/images/stars.svg"
import bag from "../assets/images/bag.svg"
export const data = [
    {
        title: "Secure",
        text: "We strictly only deal with vendors that provide top notch security.",
        img: secure
    },
    {
        title: "24/7 Support",
        text: "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud.",
        img: support
    },
    {
        title: "Customizable",
        text: "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud.",
        img: custom
    },
    {
        title: "Reliable",
        text: "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud.",
        img: reliable
    },
    {
        title: "Fast",
        text: "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud.",
        img: fast
    },
    {
        title: "Easy",
        text: "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud.",
        img: easy
    },

]
export const Data = [
    {
        num: "01",
        title: "Register",
        text: "Create an account with us using Google or Facebook.",
    },
    {
        num: "02",
        title: "Download",
        text: "Browse and Download the template that you like from the marketplace.",

    },
    {
        num: "03",
        title: "Run",
        text: "Follow the instructions to setup and customize the template to your needs.",

    },



]
export const dataTwo = [
    {
        title: "Affordable",
        text: "We promise to offer you the best rate we can - at par with the industry standard.",
        img: dollar,
        className: "bg-[#9ae6b4] text-[#276749] text-[16px] text-center rounded-full p-2"
    },
    {
        title: "Download",
        text: "Browse and Download the template that you like from the marketplace.",
        img: bag,
        className: "bg-[#feb2b2] text-[#9b2c2c] text-[16px] text-center rounded-full p-2"

    },




]
export const card = [
    {
        title: "personal",
        price: "17.99",
        img: dollar,
        time: "Monthly",
        text: "For Individuals",
        offre: ["30 Templates", "7 Landing Pages", "12 Internal Pages", "Basic Assistance"],
        btnColor: "bg-custom-color px-12 hover:shadow-lg hover:scale-105 hover:origin-top-left  transition duration-150 ease-out hover:ease-in  uppercase text-[#f7fafc] rounded-full py-3",
        className: "md:border-4 border border-custom-rgb-1 text-center text-[#f7fafc] md:w-[384px] w-[100%] h-[607.5px] rounded-md shadow-md "
    },
    {
        title: "business",
        price: "37.99",
        img: dollar,
        time: "Monthly",
        text: "For Small Businesses",
        offre: ["60 Templates", "15 Landing Pages", "22 Internal Pages", "Priority Assistance"],
        btnColor: "bg-custom-color-2 px-12 hover:scale-105 hover:origin-top-left transition duration-150 ease-out hover:ease-in  uppercase text-[#f7fafc] rounded-full py-3",
        className: "md:border-4 border border-custom-rgb-2 text-center text-[#f7fafc] md:w-[384px] w-[100%] h-[607.5px] rounded-md shadow-md"
    },
    {
        title: "Enterprise",
        price: "57.99",
        img: dollar,
        time: "Monthly",
        text: "For Large Companies",
        offre: ["90 Templates", "27 Landing Pages", "37 Internal Pages", "Priority Assistance"],
        btnColor: "bg-custom-color-3 px-12 hover:scale-105 hover:origin-top-left transition duration-150 ease-out hover:ease-in  uppercase text-[#f7fafc] rounded-full py-3",
        className: "md:border-4 border border-custom-rgb-3 text-center text-[#f7fafc] md:w-[384px] w-[100%] h-[607.5px] rounded-md shadow-md"
    },



]
export const stars = [
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>,
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>,

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>,

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>,

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>,






]
export const footerData = [
    {
        title: "main",
        text: ["Blog", "FAQs", "Support", "About us"]

    },
    {
        title: "product",
        text: ["Log in", "Personal", "Business", "Team"]
    },
    {
        title: "press",
        text: ["Logos", "Events", "Stories", "Office"]
    },
    {
        title: "team",
        text: ["Career", "Founders", "Culture", "Onboarding"]
    }
    , {
        title: "legal",
        text: ["GPDR", "Privacy Policy", "Terms of Service", "Disclaimer"]
    }




]